import Backbone from 'backbone';
import $ from 'jquery';

import * as navigation from 'Navigation';

class EmptyEntryTabState extends navigation.TabState {
  override defaults(): navigation.TabStateDefaults {
    return {
      ...super.defaults(),
      title: 'No Protocols',
      closeable: false,
      options: false,
      showInNavBar: false,
      preferenceKey: 'empty-entry',
    };
  }
}

class EmptyEntryTabView extends Backbone.View<EmptyEntryTabState> {
  static initClass(): void {
    this.prototype.className = 'buffer-tab';
  }

  override render(): this {
    this.$el
      .empty()
      .append($('<div>').addClass('buffer-tab-emptyEntryText').text('The entry has no protocols.'));
    return this;
  }
}

EmptyEntryTabView.initClass();

export {EmptyEntryTabView, EmptyEntryTabState};
